import React, { useContext } from 'react';
import history from 'store/history';
import styles from './styles.module.css';
import { backArrowDesktop, backArrowMobile, fsfLogo } from 'assets/newIcons';
import MobileContext from 'context/MobileContext';
export const Header = ({ logout }) => {
  const path = window.location.pathname;
  const isMobile = useContext(MobileContext);

  const goToHomePage = () => {
    history.push('/admin');
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className={styles.container}>
      {path === '/admin/login' ||
      path === '/admin' ||
      path === '/admin/reset-password' ? (
        <div className={`${styles.headerContainer} ${isMobile ? styles.mob : null}`}>
          <div>
            <img
              src={fsfLogo}
              alt="logo"
              className={`${styles.logo} ${isMobile ? styles.mob : null}`}
            />
          </div>
          {path === '/admin/login' || path === '/admin/reset-password' ? (
            ''
          ) : (
            <div className={styles.buttonDiv}>
              <button className={styles.button} onClick={handleLogout}>
                Sign Out
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className={styles.div}>
          <div className={`${styles.subdiv1} ${isMobile ? styles.mob : null}`}>
            <img
              alt=""
              onClick={goToHomePage}
              className={`${styles.backArrow} ${isMobile ? styles.mob : null}`}
              src={isMobile ? backArrowMobile : backArrowDesktop}
            />
          </div>
          <div className={styles.subdiv2}>
            <img src={fsfLogo} alt="logo" className={styles.logo} />
          </div>
          <div className={styles.buttonDiv}>
            <button className={styles.button} onClick={handleLogout}>
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
